<template>
  <div>
    <v-navigation-drawer
      fixed
      v-model="toolbarProps.drawer"
      app
    >
    <v-list dense>
      <v-list-tile @click.stop="toolbarProps.drawer = !toolbarProps.drawer">
        <v-list-tile-action>
          <v-icon>arrow_back</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile v-for="(item, i) in listItems" :key="i" @click="smoothNav(item.hash)">
        <v-list-tile-action>
          <v-icon>{{item.icon}}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{item.title}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    </v-navigation-drawer>
    <v-toolbar
      :color="toolbarProps.showToolbar"
      :dark="toolbarProps.darkToolbar"
      :class="toolbarProps.marginToolbar"

      fixed
      >
      <v-flex :class="logoClass">
        <v-toolbar-side-icon class="hidden-lg-and-up" @click.stop="toolbarProps.drawer = !toolbarProps.drawer"></v-toolbar-side-icon>
        <v-toolbar-title class="d-inline">carano</v-toolbar-title>
      </v-flex>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <button :class="btnCustomClass" data-target="#home" @click.prevent="smoothNav('#home', $event)">Home</button>
        <button :class="btnCustomClass" data-target="#services" @click.prevent="smoothNav('#services', $event)">Servicios</button>
        <button :class="btnCustomClass" data-target="#about" @click.prevent="smoothNav('#about', $event)">Nosotros</button>
        <button :class="btnCustomClass" data-target="#contact" @click.prevent="smoothNav('#contact', $event)">Contacto</button>
      </v-toolbar-items>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  data: () => ({
    logoClass: 'ml-5',
    toolbarProps: {
      darkToolbar: true,
      showToolbar: 'transparent',
      marginToolbar: 'mt-4',
      drawer: false,
      scrollOff: false,
    },
    btnCustomClass: 'toolbar-custom-btn',
    listItems: [
      { hash: '#home', icon: 'home', title: 'Home' },
      { hash: '#services', icon: 'build', title: 'Servicios' },
      { hash: '#about', icon: 'business', title: 'Nosotros' },
      { hash: '#contact', icon: 'contacts', title: 'Contacto' },
    ]
  }),
  methods: {
    smoothNav(hash, event) {
      document.querySelector(hash).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    },
    scroller() {
      document.querySelectorAll('.toolbar-custom-btn').forEach(btn => {
        let element = document.querySelector(btn.dataset.target);
        let elementTop = element.offsetTop -80;
        let elementBottom = elementTop + element.offsetHeight;
        if(btn.classList.contains('toolbar-active-btn')){
          btn.classList.remove('toolbar-active-btn')
        }
        if(elementTop <= window.scrollY && elementBottom >= window.scrollY){
          btn.classList.add('toolbar-active-btn');
        }
      });
      if(window.scrollY > 700) {
        this.toolbarProps.showToolbar = 'grey lighten-5';
        this.toolbarProps.darkToolbar = false;
        this.toolbarProps.marginToolbar = '';
      } else {
        this.toolbarProps.showToolbar = 'transparent';
        this.toolbarProps.darkToolbar = true;
        this.toolbarProps.marginToolbar = 'mt-4';
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.scroller);
  },
  destroyed () {
    window.removeEventListener('scroll', this.scroller);
  },
  mounted () {
    if(window.innerWidth < 1024) {
      this.logoClass = '';
    }
  }
}
</script>

<style scoped>
.toolbar-custom-btn, .toolbar-active-btn {
  padding: 0 16px;
  outline: 0;
  text-transform: uppercase;
  text-decoration: none;
  min-width: 88px;
  font-size: 14px;
  font-weight: 500;
  -webkit-box-pack: center;
  transition: .3s cubic-bezier(.25,.8,.5,1);
}

.toolbar-custom-btn:hover {
  transform: scale(1.1);
  color: #AB47BC;
}

.toolbar-active-btn {
  transform: scale(1.1);
  color: #AB47BC;
}

</style>



// WEBPACK FOOTER //
// src/components/page_structure/Toolbar.vue